import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../data/mock';
import { Avatar, AvatarFallback } from './ui/avatar';

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-20 bg-gradient-to-b from-white to-emerald-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Trusted by Businesses & Individuals
          </h2>
          <p className="text-lg text-gray-600">
            See what our customers say about making the switch to sustainable products
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {testimonials.map((testimonial) => (
            <div 
              key={testimonial.id}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300 relative"
            >
              {/* Quote Icon */}
              <div className="absolute top-6 right-6 text-emerald-100">
                <Quote className="w-12 h-12" fill="currentColor" />
              </div>

              {/* Rating */}
              <div className="flex space-x-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" />
                ))}
              </div>

              {/* Content */}
              <p className="text-gray-700 text-lg mb-6 leading-relaxed relative z-10">
                "{testimonial.content}"
              </p>

              {/* Author */}
              <div className="flex items-center space-x-4">
                <Avatar className="w-12 h-12 bg-emerald-100 text-emerald-700">
                  <AvatarFallback className="font-semibold">
                    {testimonial.avatar}
                  </AvatarFallback>
                </Avatar>
                <div>
                  <div className="font-bold text-gray-900">{testimonial.name}</div>
                  <div className="text-sm text-gray-600">{testimonial.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Badge */}
        <div className="mt-16 text-center">
          <div className="inline-flex flex-col sm:flex-row items-center gap-4 bg-white rounded-xl px-8 py-4 shadow-md">
            <div className="flex -space-x-2">
              {['PS', 'MC', 'SJ', 'DW'].map((initials, i) => (
                <Avatar key={i} className="w-10 h-10 border-2 border-white bg-emerald-600 text-white">
                  <AvatarFallback className="text-xs font-semibold">
                    {initials}
                  </AvatarFallback>
                </Avatar>
              ))}
            </div>
            <div className="text-left">
              <div className="font-bold text-gray-900">500+ Happy Customers</div>
              <div className="text-sm text-gray-600">Join businesses making a difference</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
